"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Emitter = void 0;
var events_1 = require("events");
Object.defineProperty(exports, "Emitter", { enumerable: true, get: function () { return events_1.EventEmitter; } });
